import { render, staticRenderFns } from "./PatientHistoryViewDetailsServices.vue?vue&type=template&id=7f662624&scoped=true&lang=pug&"
import script from "./PatientHistoryViewDetailsServices.vue?vue&type=script&lang=js&"
export * from "./PatientHistoryViewDetailsServices.vue?vue&type=script&lang=js&"
import style0 from "./PatientHistoryViewDetailsServices.vue?vue&type=style&index=0&id=7f662624&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f662624",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
